import { useMemo } from 'react';
import { trpc } from '@/api/trpc';
import { DEFAULT_REQUISITIES_STALE_TIME } from '@/config/constants';
import { useAppQuery, type AppQueryErrorConfig } from './useAppQuery';

/**
 * Shared query for the user's portfolios with the app-standard retry and
 * stale time. Mutations invalidate this query's key explicitly, so the stale
 * time is safe.
 */
export const usePortfolios = (options?: { enabled?: boolean; errorConfig?: AppQueryErrorConfig }) => {
    const query = useAppQuery(
        {
            ...trpc.user.fetchPortfolios.queryOptions(),
            enabled: options?.enabled,
            staleTime: DEFAULT_REQUISITIES_STALE_TIME
        },
        options?.errorConfig
    );

    const portfolios = useMemo(() => query.data?.portfolios ?? [], [query.data?.portfolios]);

    return { error: query.error, isLoading: query.isLoading, portfolios, query };
};
